package co.maytes.standupbot.dashboard.components.layout

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.features.onboarding.OnboardingStep
import co.maytes.standupbot.dashboard.stores.rememberAuthStore
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Radius
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.dashboard.styles.Typography
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.window

@Composable
fun ResumeOnboardingBanner() {
    val auth = rememberAuthStore()
    if (!auth.requiresOnboarding()) return

    val path = try {
        window.location.pathname
    } catch (_: Throwable) {
        ""
    }
    if (path.startsWith("/app/onboarding")) return

    val ws = auth.currentUser?.workspace
    val resumePath = OnboardingStep.resumePath(
        slackConnected = ws?.slackConnected == true,
        linearConnected = ws?.linearConnected == true,
    )

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .margin(bottom = Spacing.md)
            .borderRadius(Radius.md)
            .padding(topBottom = Spacing.sm, leftRight = Spacing.md)
            .styleModifier {
                property("background", "rgba(94, 106, 210, 0.08)")
                property("border", "1px solid rgba(94, 106, 210, 0.30)")
            },
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween,
    ) {
        SpanText(
            text = "Your workspace setup isn't finished yet — resume the wizard to start posting daily standups.",
            modifier = Modifier
                .fontSize(Typography.bodySmall.size)
                .color(Palette.textPrimary),
        )
        Link(
            path = resumePath,
            text = "Continue onboarding →",
            modifier = Modifier
                .fontSize(Typography.bodySmall.size)
                .fontWeight(600)
                .color(Palette.accent)
                .styleModifier { property("text-decoration", "none") },
        )
    }
}
